import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import { ZHSMRegularKek } from '../types'

const ZHSMRegularKekObj = z.object({
  total_count: z.number(),
  list: z.array(ZHSMRegularKek)
})

const ZApiResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: z.optional(ZHSMRegularKekObj)
})

export type HSMRegularKekObj = z.infer<typeof ZHSMRegularKekObj>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function getAllHsmRegumarKekListFiltered (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  filterParams: any,
  onSuccess: (hsmRegularKekObj: HSMRegularKekObj, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  let field = sortfield
  if (field === 'created At') {
    field = 'createdAt'
  } else if (field === 'created By') {
    field = 'createdBy'
  }
  const url = `/app-config-service/api/v1/crypto/all-hsm-kek-db-details?page=${page}&size=${size}&sort=${field},${sortdir}`

  interceptedAxios
    .post(url, filterParams)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      if (parseResponse.success) {
        if (parseResponse.data.data !== undefined) {
          onSuccess(parseResponse.data.data, parseResponse.data.http_status)
        } else {
          onFailure({ totalCount: 0, group_details: [] }, response.status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
